<cerrix-loader [cerrixTab]="tab" [showLoader]="!finishedLoading"></cerrix-loader>

@if (finishedLoading && detailsModel) {
    <div data-uiid="finding-report-details-page">
        @if (!hideActionBar) {
            <div class="detail-page-action-bar flex-action-bar">
                <div>
                    <button
                        data-uiid="finding-report-save-button"
                        class="btn btn-cerrix"
                        [disabled]="!saveAllowed"
                        (click)="save()"
                    >
                        <i class="fas fa-save"></i>
                        <span class="d-none d-lg-inline">{{ "detail.save" | t }}</span>
                    </button>

                    @if (detailsModel.modifiedAt) {
                        <span class="date-edited">
                            Last save: {{ detailsModel.modifiedAt | dateTimeFormat }}
                        </span>
                    }
                </div>
            </div>
        }

        <div menuSystem [cerrixTab]="tab" class="finding-report" (changeEvent)="onMenuItemClick($event)">
            <div
                menuItemId="menuItemFindingReport"
                [attr.name]="'detail.menuFindingReport' | t"
                menuicon="fas fa-clipboard-list"
                menusystemsubmenu
            >
                <div
                    menuItemId="details"
                    [attr.name]="'detail.menuDetails' | t"
                    menusystemitem
                    menuicon="fas fa-info-circle"
                >
                    <finding-report-details-main
                        [formGroup]="formGroup"
                        [detailsModel]="detailsModel"
                        [permissionsModel]="permissionsModel"
                        [editAllowed]="saveAllowed"
                    ></finding-report-details-main>
                </div>
                @if (detailsModel.guid) {
                    <div
                        menuItemId="menuItemLinks"
                        [attr.name]="'detail.menuLinks' | t"
                        menusystemsubmenu
                        menuicon="fas fa-link"
                    >
                        @if (canViewFindings) {
                            <div
                                menuItemId="findings"
                                [attr.name]="'detail.menuFindings' | t"
                                menusystemitem
                                menuicon="far fa-radar"
                            >
                                <finding-report-findings
                                    [auditGuid]="detailsModel.auditGuid"
                                ></finding-report-findings>
                            </div>
                        }
                        <div
                            menuItemId="assessments"
                            [attr.name]="'detail.menuAssessments' | t"
                            menusystemitem
                            menuicon="fas fa-poll-people"
                        >
                            <assessment-linked-overview
                                [parentGuid]="detailsModel.guid"
                                [canAdd]="permissionsModel.canAddAssessment"
                                [canDelete]="permissionsModel.canDeleteAssessment"
                            >
                            </assessment-linked-overview>
                        </div>
                        <div
                            menuItemId="documents"
                            [attr.name]="'detail.menuDocuments' | t"
                            menusystemitem
                            menuicon="far fa-file"
                        >
                            <finding-report-details-documents
                                [editAllowed]="saveAllowed"
                                [documents]="detailsModel.documents"
                                (documentsChange)="onDocumentsChange()"
                            ></finding-report-details-documents>
                        </div>
                        <div
                            [attr.name]="'detail.menuHyperlinks' | t"
                            [attr.menuItemID]="hyperlinksMenuItemId"
                            menuicon="fas fa-external-link-alt"
                            menusystemitem
                        >
                            @if (detailsModel.Hyperlinks) {
                                <div>
                                    <hyperlink-manager
                                        [Hyperlinks]="detailsModel.Hyperlinks"
                                        (HyperlinksChanged)="checkHyperlinksDirty($event)"
                                        [TargetModule]="targetModule"
                                        [Readonly]="!saveAllowed"
                                    ></hyperlink-manager>
                                </div>
                            } @else {
                                <div>
                                    <div class="fancy-loader"></div>
                                </div>
                            }
                        </div>
                    </div>

                    <div
                        menuItemId="history"
                        [attr.name]="'detail.menuHistory' | t"
                        menusystemitem
                        menuicon="fas fa-history"
                    >
                        <app-history-overview
                            [historyDataService]="findingReportService"
                            [Id]="detailsModel.guid"
                            #historyOverviewComponent
                        >
                        </app-history-overview>
                    </div>

                    <div
                        data-uiid="finding-report-detail-options"
                        menuItemId="menuItemOptions"
                        [attr.name]="'detail.menuOptions' | t"
                        menusystemitem
                        menuicon="fas fa-check-double"
                    >
                        <detail-options
                            moduleName="Finding Report"
                            [objectName]="detailsModel.name ? detailsModel.name : 'finding report'"
                            [allowDelete]="deleteAllowed"
                            (onDelete)="delete()"
                        >
                        </detail-options>
                    </div>
                }
            </div>
        </div>
    </div>
}
